import { useEffect } from 'react';
import { useRunningCount } from './store';

/**
 * Warns the user before tab close / reload while the scheduler is actively
 * executing a job. In-app navigation is safe — the scheduler is a root-level
 * singleton and job state lives in IndexedDB, so changing routes loses nothing.
 */
export function useNavigationGuard(): void {
  const hasInFlight = useRunningCount() > 0;

  useEffect(() => {
    if (!hasInFlight) return;
    const handler = (e: BeforeUnloadEvent) => {
      e.preventDefault();
      e.returnValue = '';
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hasInFlight]);
}
